import { useEffect, useRef } from 'react'
import { observer } from 'mobx-react-lite'
import { Outlet, useRevalidator } from 'react-router'
import { AuthenticationContainer } from '@/features/iam/auth/Authentication/AuthenticationContainer'
import { type AuthenticationViewModel } from '@/features/iam/auth/Authentication/AuthenticationViewModel'

interface AuthenticatedContainerProps {
  vm: AuthenticationViewModel
}

/**
 * Shows the authentication screen until signed in with a workspace selected,
 * then renders the app.
 */
export const AuthenticatedContainer = observer(function AuthenticatedContainer({
  vm,
}: AuthenticatedContainerProps) {
  const revalidator = useRevalidator()
  const { hasWorkspaceSelected } = vm
  const hadWorkspaceSelected = useRef(hasWorkspaceSelected)

  useEffect(() => {
    // The route loaders ran without a workspace while the authentication
    // screen had the user pick or sign up for one.
    if (hasWorkspaceSelected && !hadWorkspaceSelected.current) {
      void revalidator.revalidate()
    }
    hadWorkspaceSelected.current = hasWorkspaceSelected
  }, [hasWorkspaceSelected, revalidator])

  return (
    <AuthenticationContainer vm={vm}>
      {hasWorkspaceSelected && <Outlet />}
    </AuthenticationContainer>
  )
})
